import { lineAdapter } from "../adapters/lineAdapater";
import AdsCreateTemplate from "../common/AdsCreateTemplateView";

export default function CreateLineTemplateView({ template }: { template?: any }) {
  return <AdsCreateTemplate adapter={lineAdapter} template={template} />;
}